<template>
  <v-menu
    v-model="filterMenu"
    offset-y
    lazy
    :close-on-content-click="false"
    :nudge-width="200"
  >
    <v-btn
      slot="activator"
      color="primary"
      icon
      flat
    >
      <v-icon>mdi-filter</v-icon>
    </v-btn>
    <v-card class="max-shadow">
      <v-card-title class="subheading">
        Filters
      </v-card-title>
      <v-divider />
      <v-card-text>
        <v-form ref="filterForm">
          <span class="body-2">
            Status
          </span>
          <v-radio-group
            v-model="filterStatus"
            :rules="[v => v.length > 0 || 'Field is Required']"
            style="margin-top:0"
          >
            <template v-for="option in status">
              <v-checkbox
                :key="option"
                v-model="filterStatus"
                :label="option"
                :value="option"
                style="height:30px; margin-top: 0"
              />
            </template>
          </v-radio-group>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-spacer />
        <v-btn
          color="primary"
          flat
          @click="closeFilter"
        >
          Cancel
        </v-btn>
        <v-btn
          color="primary"
          flat
          @click="filterTickets"
        >
          filter
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-menu>
</template>
<script>
export default {
  name: 'TicketFilter',
  model: {
    prop: 'filtered',
    event: 'change'
  },
  props: {
    filtered: {
      type: Array,
      default: () => [],
      required: true
    }
  },
  data() {
    return {
      status: ['OPEN', 'CLOSED', 'REOPENED'],
      filterStatus: [],
      filterMenu: false
    };
  },
  watch: {
    filterMenu: {
      handler(val) {
        if (val) {
          let filters = [];
          this.filtered.forEach(status => {
            filters.push(status.toUpperCase());
          });
          this.filterStatus = filters;
        }
      },
      immediate: true
    }
  },
  methods: {
    closeFilter() {
      this.filterMenu = false;
    },
    filterTickets() {
      if (!this.$refs.filterForm.validate()) return;
      let filter = [];
      this.filterStatus.forEach(status => {
        switch (status) {
          case 'OPEN':
            filter.push('open');
            break;

          case 'CLOSED':
            filter.push('closed');
            break;

          case 'REOPENED':
            filter.push('reopened');
            break;
          default:
            break;
        }
      });
      this.$emit('change', filter);
      this.closeFilter();
    }
  }
};
</script>

